const coritiba = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "coritiba",
    nome: "Coritiba 97/98 - Uniforme 1 Retro",
    aliases: [
      "coritiba",
      "coxa",
      "verdão",
      "retro",
      "retro coritiba",
      "coritiba retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/coritiba1/97-98-01-re/coxa0.jpg",
      "/images/brasil/serie-a/coritiba1/97-98-01-re/coxa1.jpg",
      "/images/brasil/serie-a/coritiba1/97-98-01-re/coxa2.jpg",
      "/images/brasil/serie-a/coritiba1/97-98-01-re/coxa3.jpg",
      "/images/brasil/serie-a/coritiba1/97-98-01-re/coxa4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "coritiba",
    nome: "Coritiba 24/25 - Uniforme 1",
    aliases: ["coritiba", "coxa", "verdão", "coritiba 2024", "2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/coritiba1/24-25-01/coxa0.jpg",
      "/images/brasil/serie-a/coritiba1/24-25-01/coxa1.jpg",
      "/images/brasil/serie-a/coritiba1/24-25-01/coxa2.jpg",
      "/images/brasil/serie-a/coritiba1/24-25-01/coxa3.jpg",
      "/images/brasil/serie-a/coritiba1/24-25-01/coxa4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "coritiba",
    nome: "Coritiba 24/25 - Uniforme 2",
    aliases: ["coritiba", "coxa", "verdão", "coritiba 2024", "2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/coritiba1/24-25-02/coxa0.jpg",
      "/images/brasil/serie-a/coritiba1/24-25-02/coxa1.jpg",
      "/images/brasil/serie-a/coritiba1/24-25-02/coxa2.jpg",
      "/images/brasil/serie-a/coritiba1/24-25-02/coxa3.jpg",
      "/images/brasil/serie-a/coritiba1/24-25-02/coxa4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "coritiba",
    nome: "Coritiba 25/26 - Uniforme 1",
    aliases: ["coritiba", "coxa", "verdão", "coritiba 2025", "2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/coritiba1/25-26-01/coxa0.png",
      "/images/brasil/serie-a/coritiba1/25-26-01/coxa1.png",
      "/images/brasil/serie-a/coritiba1/25-26-01/coxa2.png",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "coritiba",
    nome: "Coritiba 25/26 - Uniforme 2",
    aliases: ["coritiba", "coxa", "verdão", "coritiba 2025", "2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/coritiba1/25-26-02/coxa0.png",
      "/images/brasil/serie-a/coritiba1/25-26-02/coxa1.png",
      "/images/brasil/serie-a/coritiba1/25-26-02/coxa2.png",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "coritiba",
    nome: "Coritiba 24/25 - Uniforme Edição Especial",
    aliases: ["coritiba", "coxa", "verdão", "coritiba 2024", "2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/coritiba1/24-25-00-es/coxa0.png",
      "/images/brasil/serie-a/coritiba1/24-25-00-es/coxa1.png",
    ],
  },
];
export default coritiba;
